<b3-drawer
  [open]="isOpen"
  size="md"
  overlay
  (b3-request-close)="close()"
  (b3-request-back)="close()">
  <b3-drawer-header
    heading="Detalhes da Entidade incluída"
    show-back
    back-aria-label="Fechar detalhes">
  </b3-drawer-header>

  <b3-drawer-body>
    <div class="entity-details-drawer">
      <div class="entity-details-drawer__content">
        <b3-tag
          class="entity-details-drawer__badge"
          size="sm"
          variant="filled"
          tone="info"
          icon="check_circle"
          label="Aposentadoria">
        </b3-tag>

        <div class="entity-details-drawer__grid entity-details-drawer__grid--2">
          <div class="entity-details-drawer__field">
            <span class="entity-details-drawer__label">{{ documentFieldLabel }}</span>
            <span class="entity-details-drawer__value">{{ formattedDocumentNumber }}</span>
          </div>
          <div class="entity-details-drawer__field">
            <span class="entity-details-drawer__label">Quantidade</span>
            <span class="entity-details-drawer__value">{{ beneficiary?.withdrawalAmount }}</span>
          </div>
        </div>

        <div class="entity-details-drawer__field">
          <span class="entity-details-drawer__label">Razão social</span>
          <span class="entity-details-drawer__value">{{ beneficiary?.beneficiaryName }}</span>
        </div>

        <div class="entity-details-drawer__field">
          <span class="entity-details-drawer__label">Detalhes</span>
          <p class="entity-details-drawer__value entity-details-drawer__value--description">
            {{ beneficiary?.beneficiaryDescription }}
          </p>
        </div>

        <div class="entity-details-drawer__actions">
          <b3-button
            class="entity-details-drawer__confirm-btn"
            type="button"
            variant="filled"
            tone="default"
            (b3-click)="close()">
            <b3-icon name="check_circle" size="md" tone="on-brand"></b3-icon>
            Entendi
          </b3-button>
        </div>
      </div>
    </div>
  </b3-drawer-body>
</b3-drawer>
